import { render } from "./StatsBar.vue?vue&type=template&id=3148279a&scoped=true"
import script from "./StatsBar.vue?vue&type=script&lang=js"
export * from "./StatsBar.vue?vue&type=script&lang=js"

import "./StatsBar.vue?vue&type=style&index=0&id=3148279a&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3148279a"]])

export default __exports__